import dayjs from 'dayjs';
import isEmpty from 'lodash/isEmpty';
import { getCode3Widget } from './code3Widget';
/**
 * 校验衔接时间
 * 国内或者国际中转，以第二段的起飞地和目的地作为判断
 * 缺口程，则按第一段的目的地和第二段的起飞地作为判断
 * @param {array} flights
 * @param {object} flights.departMCT
 * @param {number} flights.departMCT.gn_gn 国内转国内最短衔接时间
 * @param {number} flights.departMCT.gn_gj 国内转国际最短衔接时间
 * @param {number} flights.departMCT.gj_gj 国际转国际最短衔接时间
 * @param {number} flights.departMCT.gj_gn 国际转国内最短衔接时间
 * @param {object} flights.arriveMCT
 * @param {number} flights.arriveMCT.gn_gn 国内转国内最短衔接时间
 * @param {number} flights.arriveMCT.gn_gj 国内转国际最短衔接时间
 * @param {number} flights.arriveMCT.gj_gj 国际转国际最短衔接时间
 * @param {number} flights.arriveMCT.gj_gn 国际转国内最短衔接时间
 * @param {string} flights.arriveDate 到达日期
 * @param {string} flights.arriveTime 到达时间
 * @param {string} flights.departDate 起飞日期
 * @param {string} flights.departTime 起飞时间
 * @param {string} flights.departAirport 起飞机场三字码
 * @param {string} flights.arriveAirport 达到机场三字码
 * @returns {number} 正常符合的情况 返回 type false，不符合的情况 返回具体衔接时间不足的具体时间
 */
export default function checkConnectingTime(flights) {
    if (flights === void 0) {
        flights = [];
    }
    if (!Array.isArray(flights) || flights.length !== 2) {
        return false;
    }
    if (isEmpty(flights[0]) || isEmpty(flights[1])) {
        return false;
    }
    var shortTime = 3600000; // 衔接时间默认一小时
    var prev = flights[0];
    var next = flights[1];
    var prev_arrTimestamp = dayjs(prev.arriveDate + " " + (prev.arriveTime || prev.arrTime)).valueOf();
    var next_depTimestamp = dayjs((next.departDate || next.flightDate) + " " + (next.departTime || next.depTime)).valueOf();
    var arrCode = prev.arriveAirport || prev.arriveAirportCode || prev.arrAirport;
    var depCode = next.departAirport || next.departAirportCode || next.depAirport;
    // 缺口层判断
    if (arrCode !== depCode) {
        var arrCode3Data = getCode3Widget(arrCode);
        var depCode3Data = getCode3Widget(depCode);
        var mct = next.departMCT || next.mctMap[depCode];
        // 第一段目的地国际、第二段目的地国际
        if (arrCode3Data.isInternational && depCode3Data.isInternational) {
            shortTime = Number(mct.gj_gj) * 60 * 1000;
        }
        // 第一段目的地国内、第二段目的地国内
        if (!arrCode3Data.isInternational && !depCode3Data.isInternational) {
            shortTime = Number(mct.gn_gn) * 60 * 1000;
        }
        // 第一段目的地国内、第二段目的地国际
        if (!arrCode3Data.isInternational && depCode3Data.isInternational) {
            shortTime = Number(mct.gn_gj) * 60 * 1000;
        }
        // 第一段目的地国际、第二段目的地国内
        if (arrCode3Data.isInternational && !depCode3Data.isInternational) {
            shortTime = Number(mct.gj_gn) * 60 * 1000;
        }
        if (next_depTimestamp - prev_arrTimestamp < shortTime) {
            return shortTime;
        }
        return 0;
    }
    if (arrCode === depCode) {
        var depCode3Data = getCode3Widget(next.departAirport || next.departAirportCode || next.depAirport);
        var arrCode3Data = getCode3Widget(next.arriveAirport || next.arriveAirportCode || next.arrAirport);
        var mct = next.departMCT || next.mctMap[depCode];
        // 国内转国内
        if (!depCode3Data.isInternational && !arrCode3Data.isInternational) {
            shortTime = Number(mct.gn_gn) * 60 * 1000;
        }
        // 国内转国际
        if (!depCode3Data.isInternational && arrCode3Data.isInternational) {
            shortTime = Number(mct.gn_gj) * 60 * 1000;
        }
        // 国际转国内
        if (depCode3Data.isInternational && !arrCode3Data.isInternational) {
            shortTime = Number(mct.gj_gn) * 60 * 1000;
        }
        // 国际转国际
        if (depCode3Data.isInternational && arrCode3Data.isInternational) {
            shortTime = Number(mct.gj_gn) * 60 * 1000;
        }
        if (next_depTimestamp - prev_arrTimestamp < shortTime) {
            return shortTime;
        }
        return 0;
    }
    return 0;
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/checkConnectingTime.js
// module id = null
// module chunks = 